import React from "react";
import "./cornerShape.scss";
import purpleCornerShapeImg from "../../images/home/purple-corner-shape-img.webp";

const CornerShape = ({
    as = "div", // can be 'div' or 'section'
    className = "",
    hasCornerImg = false,
    children,
    id
}) => {
    const Wrapper = as; // Wrapper is either 'div' or 'section'

    return (
        <Wrapper className={`${hasCornerImg ? "corner-shape-img" : "corner-shape"} ${className}`} id={id}>
            {hasCornerImg && (
                <div className="media-shape">
                    <img
                        src={purpleCornerShapeImg}
                        alt=""
                        width={104}
                        height={176}
                        loading="lazy"
                    />
                </div>
            )}
            {children}
        </Wrapper>
    );
};

export default CornerShape;
